import React, { useState } from 'react';
import cn from 'clsx';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';

import {
  CardElement,
  useStripe,
  useElements,
  Elements,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { createSubscription } from '@sdk/managers/PaymentManager';

import ButtonMighty from '@components/elements/ButtonMighty';
import { useAuth } from '@hooks/Auth';
import InputText from '@components/elements/InputText';
import { debounce } from 'lodash';

interface PlanSubscribeCheckoutFormProps {
  plan: string;
}

const PlanSubscribeCheckoutForm: React.FC<PlanSubscribeCheckoutFormProps> = ({
  plan,
}) => {
  const history = useHistory<any>();
  const { dbUser, refetch, company } = useAuth();
  const stripe = useStripe();
  const elements = useElements();
  const [coupon, setCoupon] = useState('');
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  console.log(dbUser);

  const handleSubmit = async (event) => {

    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements || !dbUser) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    setSubmitting(true);

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    if (cardElement) {
      const result = await stripe.createToken(cardElement);

      if (result.error) {
        console.log('[error]', result.error);
        toast.error(result.error.message || 'Failed to use card.');
        setSubmitting(false);
      } else if (!result) {
        toast.error('Failed to use card.');
        setSubmitting(false);
      } else {
        try {
          const res = await createSubscription(
            dbUser?.id,
            plan,
            result.token.id,
            coupon
          );
          console.log(res);
          setTimeout(async () => {
            try {
              await refetch();
              toast.success(`Successfully upgraded to ${plan} tier`);
              if (plan === 'ENTERPRISE' && company === undefined) {
                history.push('/company/setup');
              } else {
                history.push('/account');
              }
            } catch (err: any) {
              console.error(err);
              if (err?.message) toast.error(err?.message);
            } finally {
              setSubmitting(false);
            }
          }, 2000);
          console.log(dbUser);
        } catch (err: any) {
          console.log({ err });
          console.error(err);
          toast.error(err?.message || 'Failed to charge subscription.');
        } finally {
          setSubmitting(false);
        }
      }
    }
  };

  const checkCoupon = debounce((value)=>{
    console.log(value)
  },1000)

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <CardElement
          options={{
            hidePostalCode: true,
            style: {
              base: {
                fontSize: '16px',
                color: '#424770',
                '::placeholder': {
                  color: '#aab7c4',
                },
              },
              invalid: {
                color: '#9e2146',
              },
            },
          }}
        />
        <InputText
          value={coupon}
          onChange={(e) => {
            setCoupon(e);
            checkCoupon(e);
          }}
          type="text"
          style={{
            marginTop: '32px',
            fontSize: '16px',
            color: '#424770',
            '::placeholder': {
              color: '#aab7c4',
            },
            background: 'black',
          }}
          placeholder="Promo code"
        />
      </div>
      <div className={cn('w-full xl:w-auto pt-4', {})}>
        <ButtonMighty
          type="submit"
          disabled={!stripe || isSubmitting}
          loading={isSubmitting}
          color="#4400FF"
          borderColor="#ff1dfc"
          textColor="#FFFF00"
          text="Subscribe"
          margin="0"
        />
      </div>
    </form>
  );
};

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// if (process.env.REACT_APP_STRIPE_PUB_KEY === undefined)
//   throw new Error(
//     `Missing stripe publishable key ${process.env.REACT_APP_STRIPE_PUB_KEY}`
//   );
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUB_KEY ||
    'pk_test_51Iffk1IXx2HzzlEOIl2w2tJmhcSXOuitzV7SAkJaqi3aqRKOcOi2ElHYBR5YRT1ESJv4NsKvhTYBNSPnYEPcdQ6G00MG5sbPSM'
);

const WrappedPlanSubscribeCheckoutForm: React.FC<PlanSubscribeCheckoutFormProps> =
  (props) => {
    return (
      <Elements stripe={stripePromise}>
        <PlanSubscribeCheckoutForm {...props} />
      </Elements>
    );
  };

export default WrappedPlanSubscribeCheckoutForm;
